import React from "react";

export default ({ photo, alt, insider }) => (
  <img
    className={`w3 w4-ns db h-auto ${insider && "self-center"}`}
    src={photo}
    alt={alt}
  />
);



// WEBPACK FOOTER //
// ./src/components/common/candidate/InsiderPhoto.js